export const reportSalesTypes = {
  SET_REPORT_SALES_FILTERS: 'SET_REPORT_SALES_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};